import 'tooltipster';

export const initTooltips = () => {
  $('.wh-related-solutions-links__link a').tooltipster({
    theme: 'tooltipster-solutions',
    arrow: false
  });

  $('.wh-solution-listing-item a').tooltipster({
    theme: 'tooltipster-solutions-list',
    arrow: false
  });
};



// WEBPACK FOOTER //
// ./src/js/helpers/tooltips.js